var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-input",
    _vm._b(
      {
        staticClass: "textarea-item",
        style: _vm._style,
        attrs: { type: "textarea", rows: _vm.rows, disabled: _vm.disabled },
        on: { blur: _vm.blur },
        model: {
          value: _vm._value,
          callback: function ($$v) {
            _vm._value = $$v
          },
          expression: "_value",
        },
      },
      "el-input",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }